import ReservationConstants from 'arbitrip-common/client/constants/ReservationConstants';

export default ReservationConstants;
